/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRiotAccountBriefDtoSchema } from "./riotAccountBriefDtoSchema.ts";
import { goodLuckCoreEntitiesTeamAccessRoleSchema } from "../entities/teamAccessRoleSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterMemberResponseSchema = z.object({
  id: z.string().nullish(),
  userId: z.string().nullish(),
  username: z.string().nullish(),
  displayName: z.string().nullish(),
  role: z.string().nullish(),
  get accessRole() {
    return goodLuckCoreEntitiesTeamAccessRoleSchema.optional();
  },
  avatarUrl: z.string().nullish(),
  isCaptain: z.optional(z.boolean()),
  joinedAt: z.optional(z.iso.datetime()),
  riotGameName: z.string().nullish(),
  riotTagLine: z.string().nullish(),
  riotRegion: z.string().nullish(),
  riotProfileIconId: z.int().nullish(),
  riotRank: z.string().nullish(),
  riotLane: z.string().nullish(),
  get riotAccounts() {
    return z.array(goodLuckCoreDTOsRiotAccountBriefDtoSchema).nullish();
  },
  hasPro: z.optional(z.boolean()),
  proNicknameStyle: z.optional(z.int()),
  proNicknameColorA: z.string().nullish(),
  proNicknameColorB: z.string().nullish(),
});
